var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"topbar"}},[_c('div',{staticClass:"right"},[_c('Language'),_c('div',{staticClass:"user"},[_vm._v(_vm._s(_vm.user.username))]),_c('div',{staticClass:"name",attrs:{"id":"logout"},on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }